import { useCallback, useState } from 'react';

export type LifeReviewMediaUploadStatus = 'idle' | 'preparing' | 'uploading' | 'success' | 'error';
export type LifeReviewTranscriptStatus = 'idle' | 'pending' | 'completed' | 'failed';
export type LifeReviewPlaybackStatus = 'idle' | 'loading' | 'ready' | 'error';

export function useLifeReviewMediaState() {
  const [uploadStatus, setUploadStatus] = useState<LifeReviewMediaUploadStatus>('idle');
  const [transcriptStatus, setTranscriptStatus] = useState<LifeReviewTranscriptStatus>('idle');
  const [playbackStatus, setPlaybackStatus] = useState<LifeReviewPlaybackStatus>('idle');

  const resetMediaState = useCallback(() => {
    setUploadStatus('idle');
    setTranscriptStatus('idle');
    setPlaybackStatus('idle');
  }, []);

  return {
    uploadStatus,
    transcriptStatus,
    playbackStatus,
    setUploadStatus,
    setTranscriptStatus,
    setPlaybackStatus,
    resetMediaState
  };
}
